function SkylightOrder({ yurtTrait, walls}) {
  return ( 
    <p>HELLO</p>
  )

}

export default SkylightOrder